export default __webpack_public_path__ + "static/media/004-road roller.fe77e1f8.svg";